import Request from '@hotmart-org-ca/request'

import Settings from 'common/helpers/settings'

const options = {
  headers: {
    'Authorization': Settings.api.key,
    'Content-Type': 'application/x-www-form-urlencoded',
    'application': 'Live'
  }
}

Request.register(Settings.api.oauth, {
  get: {
    'auth.token.check': '/rest/v1/user/me',
    'auth.check_token': '/oauth/check_token?token=:token',
    'auth.logout': '/logout'
  },
  post: {
    'auth.login': {
      options,
      path: '/oauth/token?grant_type=password&username=:username&password=:password'
    }
  }
})

Request.register(Settings.api.marketplace, {
  get: {
    'auth.user_profile': '/userprofile/rest/v1/user/profile'
  }
})

Request.register(`${Settings.api.liveManager}/v1`, {
  get: {
    'oauth.validate_token': '/refreshtoken/validate'
  },
  post: {
    'oauth.refresh_token': '/refreshtoken'
  }
})
